/** Hidden every-day test college. Only these non-admin emails may enter it. */
export const ADMIN_TEST_UNIVERSITY = 'Admin Test University'

export const ADMIN_TEST_STUDENT_EMAILS = [
  'sukumaran.sindhu@gmail.com',
  'silviavictor2010@gmail.com',
]

export const ADMIN_TEST_ADMIN_EMAILS = [
  'prashanth.ayyavu@gmail.com',
  'silvia.r.muthumani@gmail.com',
]

export function isAdminTestUniversity(name) {
  return (name || '').trim().toLowerCase() === ADMIN_TEST_UNIVERSITY.toLowerCase()
}

export function isEverydaySession(collegeOrName) {
  if (!collegeOrName) return false
  if (typeof collegeOrName === 'string') return isAdminTestUniversity(collegeOrName)
  return !!(collegeOrName.everyday || isAdminTestUniversity(collegeOrName.name))
}

export function isAdminTestStudent(email) {
  return ADMIN_TEST_STUDENT_EMAILS.includes((email || '').trim().toLowerCase())
}

/** Admins always see it. Students: only the two testers. */
export function canSeeAdminTestUniversity(email, { isAdmin = false } = {}) {
  if (isAdmin) return true
  return isAdminTestStudent(email)
}

/** UTC calendar day shown as the picked date for Admin Test University. */
export function todayUtcIso() {
  return new Date().toISOString().slice(0, 10)
}
